"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrialTypeOption = exports.PDFStatus = exports.CcpSubscriptionEndBehaviour = exports.BehaviourAtEndOfTrial = exports.LinkedProductTypes = exports.LinkedEntitlementTypes = exports.SubscriptionStatus = exports.ProductStatus = exports.EndDateBillingPeriod = exports.BillingFrequency = exports.BillingStatus = exports.EntitlementTemplateProvisioning = exports.EntitlementTemplateStatus = exports.OfferingRelationType = exports.OfferingRelationDirection = exports.IntentedBillingPeriodStates = exports.Product = exports.PromotionStatus = exports.PromotionSaleTransitionType = exports.PromotionPartnerTier = exports.PromotionCycleInterval = exports.InvoiceDunningStatusAttempt = exports.InvoiceStatus = exports.SyntheticPricingPlanStatus = exports.HostingType = exports.OfferingStatus = exports.PricingType = exports.OfferingType = exports.ChargeElementType = exports.InvoiceRequestsStatus = exports.CcpPaymentMethodTypes = void 0;
var CcpPaymentMethodTypes;
(function (CcpPaymentMethodTypes) {
    CcpPaymentMethodTypes["CARD"] = "CARD";
    CcpPaymentMethodTypes["DEFERRED"] = "DEFERRED";
    CcpPaymentMethodTypes["PAYPAL"] = "PAYPAL";
})(CcpPaymentMethodTypes || (exports.CcpPaymentMethodTypes = CcpPaymentMethodTypes = {}));
var InvoiceRequestsStatus;
(function (InvoiceRequestsStatus) {
    InvoiceRequestsStatus["OPEN"] = "OPEN";
    InvoiceRequestsStatus["PENDING"] = "PENDING";
})(InvoiceRequestsStatus || (exports.InvoiceRequestsStatus = InvoiceRequestsStatus = {}));
var ChargeType;
(function (ChargeType) {
    ChargeType["METERED"] = "METERED";
    ChargeType["LICENSED"] = "LICENSED";
})(ChargeType || (ChargeType = {}));
var ACTIVE;
(function (ACTIVE) {
    ACTIVE["ACTIVE"] = "ACTIVE";
    ACTIVE["INACTIVE"] = "INACTIVE";
})(ACTIVE || (ACTIVE = {}));
var ChargeElementType;
(function (ChargeElementType) {
    ChargeElementType["USER"] = "user";
    ChargeElementType["AGENT"] = "agent";
    ChargeElementType["OBJECT"] = "object";
    ChargeElementType["VIRTUAL_AGENT"] = "conversation";
    ChargeElementType["UNIT"] = "unit";
})(ChargeElementType || (exports.ChargeElementType = ChargeElementType = {}));
var OfferingType;
(function (OfferingType) {
    OfferingType["PARENT"] = "PARENT";
    OfferingType["CHILD"] = "CHILD";
})(OfferingType || (exports.OfferingType = OfferingType = {}));
var PricingType;
(function (PricingType) {
    PricingType["FREE"] = "FREE";
    PricingType["LIMITED_FREE"] = "LIMITED_FREE";
    PricingType["PAID"] = "PAID";
    PricingType["EXTERNAL"] = "EXTERNAL";
})(PricingType || (exports.PricingType = PricingType = {}));
var OfferingStatus;
(function (OfferingStatus) {
    OfferingStatus["DRAFT"] = "DRAFT";
    OfferingStatus["ACTIVE"] = "ACTIVE";
    OfferingStatus["DEACTIVATED"] = "DEACTIVATED";
    OfferingStatus["DELETED"] = "DELETED";
    OfferingStatus["EXPIRED"] = "EXPIRED";
    OfferingStatus["AT_NOTICE"] = "AT_NOTICE";
})(OfferingStatus || (exports.OfferingStatus = OfferingStatus = {}));
var HostingType;
(function (HostingType) {
    HostingType["CLOUD"] = "CLOUD";
})(HostingType || (exports.HostingType = HostingType = {}));
var SyntheticPricingPlanStatus;
(function (SyntheticPricingPlanStatus) {
    SyntheticPricingPlanStatus["ACTIVE"] = "ACTIVE";
    SyntheticPricingPlanStatus["INACTIVE"] = "INACTIVE";
    SyntheticPricingPlanStatus["REPLACED"] = "REPLACED";
})(SyntheticPricingPlanStatus || (exports.SyntheticPricingPlanStatus = SyntheticPricingPlanStatus = {}));
var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["INVOICED"] = "INVOICED";
    InvoiceStatus["PAID"] = "PAID";
    InvoiceStatus["CREATED"] = "CREATED";
    InvoiceStatus["DECLINED"] = "DECLINED";
    InvoiceStatus["DELETED"] = "DELETED";
    InvoiceStatus["DRAFT"] = "DRAFT";
    InvoiceStatus["OPEN"] = "OPEN";
    InvoiceStatus["PARTIALLY_REFUNDED"] = "PARTIALLY_REFUNDED";
    InvoiceStatus["PENDING_PAYMENT"] = "PENDING_PAYMENT";
    InvoiceStatus["REFUNDED"] = "REFUNDED";
    InvoiceStatus["RESERVED"] = "RESERVED";
    InvoiceStatus["UNCOLLECTIBLE"] = "UNCOLLECTIBLE";
    InvoiceStatus["VOID"] = "VOID";
    InvoiceStatus["PAYMENT_DEFERRED"] = "PAYMENT_DEFERRED";
    InvoiceStatus["DEFERRED_PAID"] = "DEFERRED_PAID";
})(InvoiceStatus || (exports.InvoiceStatus = InvoiceStatus = {}));
var InvoiceDunningStatusAttempt;
(function (InvoiceDunningStatusAttempt) {
    InvoiceDunningStatusAttempt["ONE"] = "ONE";
    InvoiceDunningStatusAttempt["TWO"] = "TWO";
    InvoiceDunningStatusAttempt["THREE"] = "THREE";
    InvoiceDunningStatusAttempt["FOUR"] = "FOUR";
    InvoiceDunningStatusAttempt["FIVE"] = "FIVE";
})(InvoiceDunningStatusAttempt || (exports.InvoiceDunningStatusAttempt = InvoiceDunningStatusAttempt = {}));
var PromotionCycleInterval;
(function (PromotionCycleInterval) {
    PromotionCycleInterval["DAY"] = "DAY";
    PromotionCycleInterval["WEEK"] = "WEEK";
    PromotionCycleInterval["MONTH"] = "MONTH";
    PromotionCycleInterval["YEAR"] = "YEAR";
})(PromotionCycleInterval || (exports.PromotionCycleInterval = PromotionCycleInterval = {}));
var PromotionPartnerTier;
(function (PromotionPartnerTier) {
    PromotionPartnerTier["SILVER"] = "SILVER";
    PromotionPartnerTier["PLATINUM"] = "PLATINUM";
    PromotionPartnerTier["GOLD"] = "GOLD";
    PromotionPartnerTier["ACCESS"] = "ACCESS";
})(PromotionPartnerTier || (exports.PromotionPartnerTier = PromotionPartnerTier = {}));
var PromotionSaleTransitionType;
(function (PromotionSaleTransitionType) {
    PromotionSaleTransitionType["NEW"] = "NEW";
    PromotionSaleTransitionType["UPGRADE"] = "UPGRADE";
    PromotionSaleTransitionType["DOWNGRADE"] = "DOWNGRADE";
    PromotionSaleTransitionType["RENEWAL"] = "RENEWAL";
})(PromotionSaleTransitionType || (exports.PromotionSaleTransitionType = PromotionSaleTransitionType = {}));
var PromotionStatus;
(function (PromotionStatus) {
    PromotionStatus["DRAFT"] = "DRAFTED";
    PromotionStatus["ACTIVE"] = "ACTIVE";
    PromotionStatus["DEACTIVATED"] = "DEACTIVATED";
    PromotionStatus["DELETED"] = "DELETED";
})(PromotionStatus || (exports.PromotionStatus = PromotionStatus = {}));
var Product;
(function (Product) {
    Product["STATUSPAGE"] = "STATUSPAGE";
})(Product || (exports.Product = Product = {}));
var IntentedBillingPeriodStates;
(function (IntentedBillingPeriodStates) {
    IntentedBillingPeriodStates["PAID"] = "PAID";
    IntentedBillingPeriodStates["TRIAL"] = "TRIAL";
})(IntentedBillingPeriodStates || (exports.IntentedBillingPeriodStates = IntentedBillingPeriodStates = {}));
var OfferingRelationDirection;
(function (OfferingRelationDirection) {
    OfferingRelationDirection["TO"] = "TO";
})(OfferingRelationDirection || (exports.OfferingRelationDirection = OfferingRelationDirection = {}));
var OfferingRelationType;
(function (OfferingRelationType) {
    OfferingRelationType["APP_DEPENDENCE"] = "APP_DEPENDENCE";
})(OfferingRelationType || (exports.OfferingRelationType = OfferingRelationType = {}));
var EntitlementTemplateStatus;
(function (EntitlementTemplateStatus) {
    EntitlementTemplateStatus["NONE"] = "NONE";
    EntitlementTemplateStatus["UNPUBLISHED"] = "UNPUBLISHED";
    EntitlementTemplateStatus["PUBLISHED"] = "PUBLISHED";
    EntitlementTemplateStatus["DEPRECATED"] = "DEPRECATED";
})(EntitlementTemplateStatus || (exports.EntitlementTemplateStatus = EntitlementTemplateStatus = {}));
var EntitlementTemplateProvisioning;
(function (EntitlementTemplateProvisioning) {
    EntitlementTemplateProvisioning["SELF"] = "SELF";
    EntitlementTemplateProvisioning["PLS_ORCHESTRATION_ADAPTER"] = "PLS_ORCHESTRATION_ADAPTER";
})(EntitlementTemplateProvisioning || (exports.EntitlementTemplateProvisioning = EntitlementTemplateProvisioning = {}));
var BillingStatus;
(function (BillingStatus) {
    BillingStatus["ACTIVE"] = "ACTIVE";
    BillingStatus["DELETED"] = "DELETED";
    BillingStatus["SUSPENDED"] = "SUSPENDED";
    BillingStatus["INACTIVE"] = "INACTIVE";
    BillingStatus["NOT_STARTED"] = "NOT_STARTED";
})(BillingStatus || (exports.BillingStatus = BillingStatus = {}));
var BillingFrequency;
(function (BillingFrequency) {
    BillingFrequency["ANNUAL"] = "ANNUAL";
    BillingFrequency["MONTHLY"] = "MONTHLY";
    BillingFrequency["OTHER"] = "OTHER";
})(BillingFrequency || (exports.BillingFrequency = BillingFrequency = {}));
var EndDateBillingPeriod;
(function (EndDateBillingPeriod) {
    EndDateBillingPeriod["CUSTOM"] = "custom";
    EndDateBillingPeriod["MONTHS_12"] = "12";
    EndDateBillingPeriod["MONTHS_24"] = "24";
    EndDateBillingPeriod["MONTHS_36"] = "36";
})(EndDateBillingPeriod || (exports.EndDateBillingPeriod = EndDateBillingPeriod = {}));
var ProductStatus;
(function (ProductStatus) {
    ProductStatus["EXPIRED"] = "EXPIRED";
})(ProductStatus || (exports.ProductStatus = ProductStatus = {}));
var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["CANCELLED"] = "CANCELLED";
})(SubscriptionStatus || (exports.SubscriptionStatus = SubscriptionStatus = {}));
// Defines various types of entitlement which will get rendered on AC UI.
var LinkedEntitlementTypes;
(function (LinkedEntitlementTypes) {
    LinkedEntitlementTypes["PROD_ENTITLEMENT_PRODUCT"] = "PROD_ENTITLEMENT_PRODUCT";
    LinkedEntitlementTypes["PROD_ENTITLEMENT_APP"] = "PROD_ENTITLEMENT_APP";
    LinkedEntitlementTypes["SANDBOX_PRODUCT_ENTITLEMENT"] = "SANDBOX_PRODUCT_ENTITLEMENT";
    LinkedEntitlementTypes["SANDBOX_APP_ENTITLEMENT"] = "SANDBOX_APP_ENTITLEMENT";
    LinkedEntitlementTypes["ENTERPRISE_PARENT"] = "ENTERPRISE_PARENT";
    LinkedEntitlementTypes["ENTERPRISE_INSTANCE"] = "ENTERPRISE_INSTANCE";
    LinkedEntitlementTypes["PROD_ENTITLEMENT_ADDON"] = "PROD_ENTITLEMENT_ADDON";
    LinkedEntitlementTypes["MULTI_INSTANCE"] = "MULTI_INSTANCE";
    LinkedEntitlementTypes["COLLECTION"] = "COLLECTION";
})(LinkedEntitlementTypes || (exports.LinkedEntitlementTypes = LinkedEntitlementTypes = {}));
var LinkedProductTypes;
(function (LinkedProductTypes) {
    LinkedProductTypes["JIRA"] = "JIRA";
    LinkedProductTypes["CONFLUENCE"] = "CONFLUENCE";
    LinkedProductTypes["STATUSPAGE"] = "STATUSPAGE";
    LinkedProductTypes["ACCESS"] = "ACCESS";
    LinkedProductTypes["OTHER"] = "OTHER";
})(LinkedProductTypes || (exports.LinkedProductTypes = LinkedProductTypes = {}));
var BehaviourAtEndOfTrial;
(function (BehaviourAtEndOfTrial) {
    BehaviourAtEndOfTrial["CONVERT_TO_PAID"] = "CONVERT_TO_PAID";
    BehaviourAtEndOfTrial["CANCEL"] = "CANCEL";
    BehaviourAtEndOfTrial["REVERT_TRIAL"] = "REVERT_TRIAL";
})(BehaviourAtEndOfTrial || (exports.BehaviourAtEndOfTrial = BehaviourAtEndOfTrial = {}));
var CcpSubscriptionEndBehaviour;
(function (CcpSubscriptionEndBehaviour) {
    CcpSubscriptionEndBehaviour["TRIAL_PLAN"] = "TRIAL_PLAN";
    CcpSubscriptionEndBehaviour["BILLING_PLAN"] = "BILLING_PLAN";
})(CcpSubscriptionEndBehaviour || (exports.CcpSubscriptionEndBehaviour = CcpSubscriptionEndBehaviour = {}));
var PDFStatus;
(function (PDFStatus) {
    PDFStatus["NOT_FOUND"] = "NOT_FOUND";
    PDFStatus["IN_PROGRESS"] = "IN_PROGRESS";
    PDFStatus["AVAILABLE_FOR_DOWNLOAD"] = "AVAILABLE_FOR_DOWNLOAD";
})(PDFStatus || (exports.PDFStatus = PDFStatus = {}));
var TrialTypeOption;
(function (TrialTypeOption) {
    TrialTypeOption["REGULAR_TRIAL"] = "regular trial";
    TrialTypeOption["CLOUD_MIGRATION_TRIAL"] = "cloud migration trial";
})(TrialTypeOption || (exports.TrialTypeOption = TrialTypeOption = {}));
